export default "__VITE_ASSET__CEpWxcxr__"